import { useEffect, useState } from 'react';

import { FirebaseService, httpService } from '@flexo/general';
import { KPI, USER, ALERT } from '@flexo/reducers';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

const ENV = (import.meta as any).env;

const firebaseService = new FirebaseService();

export const KwickInvoicesResolver = () => {
  const params: any = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const pathSegment = location.pathname.split('/')[1];
  const metadata = useSelector((state: any) => state.metadata);
  const { sites } = metadata?.entities;

  const [ context, setContext ] = useState<any>(null);

  async function InvoicesInit() {

      
      if (pathSegment?.includes('member')) {
        setContext('member');
      }
      if (pathSegment?.includes('community')) {
        setContext('community');
      }
      if (pathSegment?.includes('site') || pathSegment?.includes('household')) {
        setContext('site');
      }
      if (pathSegment?.includes('communities')) {
        setContext('communities');
      }

    const idToken = await firebaseService.getIdToken();

    if (!idToken) {
      dispatch(ALERT.SetAlert({
        value: {
          type: 'BANNER_SESSION_EXPIRED',
        },
      } as any));

      dispatch(USER.SetLogout());

      return;
    }
      
    let sitesIds: Array<string> = [];
    

      if (context === 'site') {
        sitesIds.push(params?.id as string);
      }
      if (context === 'member') {
        sitesIds = sites.filter((site: any) => site.memberId === params?.id).map((site: any) => site.siteId);
      }
      if (context === 'community') {
        sitesIds = sites.filter((site: any) => site.communityId === params.id).map((site: any) => site.siteId);
      }
      if (context === 'communities') {
        sitesIds = sites.map((site: any) => site.siteId);
      }

      if ( sitesIds.length === 0 ) {
        return;
      }
    
      

    const [invoices, overview] = await Promise.all([
      httpService
        .post({
          url: `${ENV.VITE_APP_BASE_URL}/kwick-staging/hive/customApi/v1/kwick/getInvoices`,
          idToken,
          data: {
            site_ids: sitesIds,
          },
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText
            // });
            return null;
          }
        })

        .catch((err: any) => {
          // console.warn(err);

          dispatch(ALERT.SetAlert({
            value: {
              type: 'BANNER_UNEXPECTED_ERROR',
            },
          } as any));
        }),
      httpService
        .post({
          url: `${ENV.VITE_APP_BASE_URL}/kwick-staging/hive/customApi/v1/kwick/getInvoicesOverview`,
          idToken,
          data: {
            site_ids: sitesIds,
          },
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText
            // });
            return null;
          }
        })

        .catch((err: any) => {
          // console.warn(err);

          dispatch(ALERT.SetAlert({
            value: {
              type: 'BANNER_UNEXPECTED_ERROR',
            },
          } as any));
        }),
    ]);
      
    dispatch(
      KPI.SetKwickInvoices([invoices, overview] as any)
      );
  }

  useEffect(() => {
    InvoicesInit();
  }, [ pathSegment, params?.id, metadata?.entities?.sites, context ]);

  return <></>;
};

